import React, { useState } from 'react';
import { getIn } from 'seamless-immutable';
import styled from 'styled-components';

const Iframe = styled.iframe`
  width: 100%;
  height: ${({ height }) => height}px;
`;

const isServer = typeof window === 'undefined';

const Iframeurl = ({ publication, src }) => {
  const [heightState, setHeightState] = useState(publication?.frameHeight || 200);

  if ((!publication && !src) || isServer) {
    return null;
  }

  const getLink = () => {
    if (src) {
      return src;
    }

    return getIn(publication, ['url']);
  };

  const adjustHeight = event => {
    const link = getLink();

    if (link.indexOf(event.origin) > -1 && event.data.type == 'setHeight') {
      setHeightState(event.data.value);
      window.removeEventListener('message', adjustHeight, false);
    }
  };

  window.addEventListener('message', e => adjustHeight(e), false);

  return <Iframe src={getLink()} height={parseInt(heightState)} />;
};

export default Iframeurl;
